import React from 'react';
import { motion } from 'framer-motion';
import { XCircle } from 'lucide-react';
export function PainPoints() {
  const pains = ['Empiezas motivada y lo sueltas a los días', 'Visualizas sin claridad y te frustras', "Te pesa: 'no merezco / no soy suficiente'", 'Tu mente te sabotea cuando vas a avanzar', 'Quieres cambiar, pero te quedas en lo mental', 'Te comparas y te apagas'];
  return <section className="py-12 bg-white" data-id="element-147">
      <div className="max-w-4xl mx-auto px-4" data-id="element-148">
        <div className="text-center mb-12" data-id="element-149">
          <h2 className="text-3xl md:text-4xl font-bold text-[#2B0A3D] mb-4" data-id="element-150">
            Si ya intentaste manifestar y sientes que 'no funciona'…
          </h2>
          <div className="w-20 h-1 bg-[#D4AF37] mx-auto rounded-full" data-id="element-151"></div>
        </div>

        <div className="grid md:grid-cols-2 gap-6" data-id="element-152">
          {pains.map((pain, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="flex items-start gap-4 p-4 rounded-xl hover:bg-red-50/50 transition-colors" data-id="element-153">
              <XCircle className="w-6 h-6 text-red-400 flex-shrink-0 mt-1" data-id="element-154" />
              <p className="text-lg text-gray-700 font-medium" data-id="element-155">{pain}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}